<template>
  <div class="container overflow-hidden ">
    <div class="row gx-5">
      <div class="col-3">
        <div class=" border bg-light">
          <div class="col">
            <div class="divider" />
            <div class="md-2">
              <button
                type="button"
                class="btn btn-success mt-2 ml-0"
                @click="salvar()"
              >
                Salvar
              </button>
              <!-- enviarArquivoPausa(); -->

              <router-link
                :to="`/player/${this.vslId}/customizacao`"
                class="btn btn-outline-secondary  mt-2 ml-1"
              >
                Voltar
              </router-link>
            </div>
          </div>
          <div class="divider" />
          <div class="">
            <h1>
              <feather-icon
                icon="ImageIcon"
                size="28"
                stroke="red"
                class="mr-50"
              />
              Thumbnails
            </h1>
          </div>
          <div class="container ">

            <form>
              <div class="divider" />
              <div class="row">
                <div id="thumb-inicio">
                  <h3>Thumbnail de Início</h3>
                  <label
                    class="picture"
                    for="picture__input"
                    tabIndex="0"
                  >
                    <span class="picture__image" />
                    <input
                      id="picture__input"
                      type="file"
                      name="picture__input"
                      @change="uploadImageUrl($event, 'picture__image')"
                    >
                    <img
                      :src="imageUrlInicio"
                      class="rounded image_src "
                    >
                  </label>
                  <!-- <el-progress max="" :percentage="uploadPercentage" /> -->
                  <div class="col" />
                </div>
                <div
                  v-if="valid == true"
                  class="col"
                >
                  <el-row class="d-flex justify-content-center">
                    <el-button
                      icon="el-icon-delete"
                      plain
                      type="danger"
                      @click="deletarAWS(Thumb[0].tumb_key_name_start); DeletThumb()"
                    >Deletar
                    </el-button>
                    <!-- <el-button icon="el-icon-upload2">Novo Upload</el-button> -->

                  </el-row>
                </div>

              </div>
              <div class="divider" />
              <div class="row">
                <div id="thumb-pause">
                  <h3>Thumbnail de Pause</h3>

                  <label
                    class="picture"
                    for="Input_UploadPausa"
                    tabIndex="0"
                  >
                    <span class="picture__imageUpload" />
                    <input
                      id="Input_UploadPausa"
                      ref="upload"
                      type="file"
                      name="Input_UploadPausa"
                      @change="uploadImageUrl($event, 'picture__imageUpload')"
                    >
                    <img
                      :src="imageUrlPausa"
                      class="rounded image_src"
                    >
                  </label>
                </div>
                <div
                  v-if="validPausa == true"
                  class="col"
                >
                  <el-row class=" d-flex justify-content-center">
                    <el-button
                      icon="el-icon-delete"
                      plain
                      type="danger"
                      @click="deletarAWSPausa(Thumb[0].thumb_key_name_pausa); DeletThumbPausa()"
                    >Deletar
                    </el-button>
                    <!-- <el-button icon="el-icon-upload2">Novo Upload</el-button> -->
                  </el-row>
                </div>
              </div>
              <div class="divider" />
              <div class="row">
                <div id="thumb-final">
                  <h3>Thumbnail de Final</h3>
                  <label
                    class="picture"
                    for="Input_UploadFinal"
                    tabIndex="0"
                  >
                    <span class="pictureFinal" />
                    <input
                      id="Input_UploadFinal"
                      ref="upload"
                      type="file"
                      name="Input_UploadFinal"
                      @change="uploadImageUrl($event, 'pictureFinal')"
                    >
                    <img
                      :src="imageUrlEnd"
                      class="rounded image_src "
                    >
                  </label>
                </div>
                <div
                  v-if="validFinal == true"
                  class="col"
                >
                  <el-row class="d-flex justify-content-center">
                    <el-button
                      icon="el-icon-delete"
                      plain
                      type="danger"
                      @click="deletarAWSFinal(Thumb[0].thumb_key_name_end); DeletThumbFinal()"
                    >Deletar
                    </el-button>
                    <!-- <el-button icon="el-icon-upload2">Novo Upload</el-button> -->
                  </el-row>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col player">
        <video
          ref="mainVideo"
          class="player_my_video viewer"
          :poster="dadosVideo.thumb.thumbStart"
          :src="dadosVideo.URL"
          type="video/mp4"
        />
        <div
          v-if="dadosVideo.autoPlayer.autoPlayerAtivo"
          class="iniciar center"
          :style="'background-color:' + dadosVideo.autoPlayer.bgColorAuto"
        >
          <h2
            class="m-4"
            :style="'color:' + dadosVideo.autoPlayer.textColorAuto"
            _msthash="1354873"
            _msttexthash="308412"
          >{{ dadosVideo.autoPlayer.textBottom }}</h2>
          <div class="loader"><span class="stroke" /><span class="stroke" /><span class="stroke" /><span
            class="stroke"
          /><span class="stroke" /><span class="stroke" /><span
            class="stroke"
          /><span class="stroke" /><span class="stroke" /><span
            class="stroke"
          /><span class="stroke" /><span class="stroke" />
          </div>
          <h2
            class="mt-0"
            :style="'color:' + dadosVideo.autoPlayer.textColorAuto"
            _msthash="1354874"
            _msttexthash="413270"
          >{{ dadosVideo.autoPlayer.textTop }}</h2>
        </div>
        <div
          v-if="dadosVideo.autoPlayer.autoPlayerAtivo === 0"
          class="playpause"
          :style="'background-color:' + getControls[0].controls_back_color"
        />
        <div
          ref="plapausebg"
          class="playpausebg"
          :style="'background-image:url(' + dadosVideo.thumb.thumbPause + ');'"
          hidden
        />
        <div
          class="playEndedbg"
          :style="'background-image:url(' + dadosVideo.thumb.thumbEnd + ');'"
          hidden
        />
        <nav
          id="navega"
          class="player_my_controls"
        >

          <div
            v-if="getControls[0].controls_progress_bar === 1"
            class="progress"
            :style="'height:' + dadosVideo.barra.bar_hight + 'px;'"
          >
            <div
              class="progress_my_filled"
              :style="'background-color:' + dadosVideo.barra.bar_cor + ';flex-basis: 10.9778%;'"
            />
          </div>
          <button
            v-show="getControls[0].controls_bt_small_player === 1"
            class="player_my_button toggle"
            _msthash="1603160"
            _msttexthash="878514"
          >▶
          </button>
          <button
            v-show="getControls[0].controls_retro_10s === 1"
            class="player_my_button button_retroceder "
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              fill="none"
              d="M0 0h24v24H0V0z"
            />
            <path
              d="M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
              fill="#FFF"
              class="color000000 svgShape"
            />
          </svg></button>
          <button
            v-show="getControls[0].controls_avan_10s === 1"
            class="player_my_button button_avancar"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              d="M18.92 13c-.5 0-.91.37-.98.86-.48 3.37-3.77 5.84-7.42 4.96-2.25-.54-3.91-2.27-4.39-4.53C5.32 10.42 8.27 7 12 7v2.79c0 .45.54.67.85.35l3.79-3.79c.2-.2.2-.51 0-.71l-3.79-3.79c-.31-.31-.85-.09-.85.36V5c-4.94 0-8.84 4.48-7.84 9.6.6 3.11 2.9 5.5 5.99 6.19 4.83 1.08 9.15-2.2 9.77-6.67.09-.59-.4-1.12-1-1.12zm-8.02 3v-4.27h-.09l-1.77.63v.69l1.01-.31V16zm3.42-4.22c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
              fill="#fff"
              class="color000000 svgShape"
            />
          </svg></button>
          <button
            v-show="getControls[0].controls_video_vol === 1"
            class="player_my_button button_volume"
          >
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path
                fill="#fff"
                d="M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063q-1.547 1.313-3.656 1.828v-2.063q1.172-0.328 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12q0-2.391-1.383-4.219t-3.586-2.484v-2.063q3.047 0.656 5.016 3.117t1.969 5.648q0 2.203-1.031 4.172l-1.5-1.547q0.516-1.266 0.516-2.625zM16.5 12q0 0.422-0.047 0.609l-2.438-2.438v-2.203q1.031 0.516 1.758 1.688t0.727 2.344z"
              />
            </svg>

          </button>

          <button
            v-show="getControls[0].controls_bt_screem === 1"
            class="player_my_button fullscreenbtn"
          >
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path
                fill="#fff"
                d="M14.016 5.016h4.969v4.969h-1.969v-3h-3v-1.969zM17.016 17.016v-3h1.969v4.969h-4.969v-1.969h3zM5.016 9.984v-4.969h4.969v1.969h-3v3h-1.969zM6.984 14.016v3h3v1.969h-4.969v-4.969h1.969z"
              />
            </svg>
          </button>
          <button
            v-show="getControls[0].controls_picture_in_picture === 1"
            class="player_my_button PictureInPicture"
          >
            <svg
              viewBox="0 0 24 24"
              width="20"
              height="20"
            >
              <path
                fill="#fff"
                d="M21 19.031v-14.063h-18v14.063h18zM23.016 18.984q0 0.797-0.609 1.406t-1.406 0.609h-18q-0.797 0-1.406-0.609t-0.609-1.406v-14.016q0-0.797 0.609-1.383t1.406-0.586h18q0.797 0 1.406 0.586t0.609 1.383v14.016zM18.984 11.016v6h-7.969v-6h7.969z"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>

  </div>
</template>

<script>

import axios from 'axios'
import { ThumbNailsService } from '@/services/Thumbnails'
import { ControlsService } from '@/services/Controls'
import Detalhes from '../../EditarVideo/Detalhes.vue'

export default {
  components:
  {
    Detalhes,
  },
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3,
      userData: JSON.parse(localStorage.getItem('userData')),
      vslId: this.$route.params.vslId,
      errorMessage: null,
      loading: false,

      valid: '',
      validPausa: '',
      validFinal: '',

      imageUrlInicio: '',
      imageUrlPausa: '',
      imageUrlEnd: '',

      dialogImageUrl: '',
      dialogVisible: false,

      uploadPercentage: 0,

      urlImagem: '',
      key_name: '',
      urlImagemPausa: '',
      key_namePausa: '',
      urlImagemFinal: '',
      key_nameFinal: '',

      Thumb: [],
      files: [],
      filesPausa: [],
      filesFinal: [],
      playx: 'true',

      control: [],
      dadosVideo: [],
    }
  },
  computed: {
    getControls() {
      return this.control
    },
    getVideoSetting() {
      return this.dadosVideo
    },
  },

  mounted() {
    this.listar()

    this.UploadImgFinal()
    this.UploadImgPausa()
    this.UploadImg()
  },

  async created() {
    try {
      const response = await ThumbNailsService.getALLThumbnails()
      this.Thumb = response.data
      const controle = await ControlsService.getControlVSL_Id(this.vslId)
      console.log(this.vslId)
      this.control = controle.data
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  methods: {
    formatTime(time) {
      // Pega os segundos, minutos e horas
      let seconds = Math.floor(time % 60)
      let minutes = Math.floor(time / 60) % 60
      let hours = Math.floor(time / 3600)

      // adiciona 0 antes do numero se o for menor que 10;
      seconds = seconds < 10 ? `0${seconds}` : seconds
      minutes = minutes < 10 ? `0${minutes}` : minutes
      hours = hours < 10 ? `0${hours}` : hours

      if (hours == 0) {
        return `${minutes}:${seconds}`
      }
      return `${hours}:${minutes}:${seconds}`
    },
    jsonPersonalizado() {
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
            console.log(this.dadosVideo)
          }
        })
    },
    togglePlay() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      const togglePausePlay = player.querySelector('.playpause')
      const togglePausePlaybg = player.querySelector('.playpausebg')
      const toggleEndedbg = player.querySelector('.playEndedbg')
      const iniciar = player.querySelector('.iniciar')

      if (video.ended) {
        console.log('PRIMEIRO')
        toggleEndedbg.setAttribute('hidden', '')
        console.log('togglePausePlay')
      }
      if (video.paused) {
        console.log('PRIMEIRO2')
        video.play()

        togglePausePlay.setAttribute('hidden', '')
        togglePausePlaybg.setAttribute('hidden', '')

        video.muted = false
      } else if (this.playx == 'true') {
        ('Caiu aqui')
        iniciar.style.visibility = 'hidden'
        video.muted = false
        video.load()
        this.playx = false
      } else {
        video.pause()

        console.log('pausado')
        togglePausePlay.removeAttribute('hidden')
        togglePausePlaybg.removeAttribute('hidden')
      }
    },
    avancar() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime += 10
    },

    retroceder() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime -= 10
    },
    toggleFullScreen() {
      const player = document.querySelector('.player')

      if (!document.fullscreenElement && !document.mozFullScreenElement
        && !document.webkitFullScreenElement && !document.msFullScreenElement) {
        if (player.requestFullscreen) {
          player.requestFullscreen()
        } else if (player.msRequestFullscreen) {
          player.msRequestFullScreen()
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen()
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen()
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen()
        }
      } else if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    },

    updateButton() {
      const player = document.querySelector('.player')
      const toggle = player.querySelector('.toggle')
      const icon = this.paused ? '▶' : '❚❚'
      console.log(icon)
      toggle.textContent = icon
      console.log('mudei')
    },
    handleProgress(e) {
      var percentReal; let
        percentFake
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')

      const progressBar = player.querySelector('.progress_my_filled')
      const togglePausePlay = player.querySelector('.playpause')
      const toggleEndedbg = player.querySelector('.playEndedbg')

      const { currentTime, duration } = e.target // pegar o time atual e a duração
      const percent = (currentTime / duration) * 100 // pega o percentual
      progressBar.style.width = `${percent}%` // passa a porcentagem para o WIDTH do progresso
      console.log(this.formatTime(currentTime))

      if (video.ended) {
        toggleEndedbg.removeAttribute('hidden')
        togglePausePlay.removeAttribute('hidden')
        console.log('VIDEO FINALIZADO...', video.ended)
      }

      // let timelineWidth = this.$refs.mainVideo.clientWidth; // pega o videoTimeline width
      // progressBar.style.width = `${e.offsetX}px`; // passing offsetX value as progressbar width
      // this.$refs.mainVideo.currentTime = (e.offsetX / timelineWidth) * this.$refs.mainVideo.duration; // atualiza time atual do video

      percentFake = (video.currentTime / 150) * 100
      if (percentFake <= 50) {
        var percentReal = (video.currentTime / 150) * 100
        progressBar.style.flexBasis = `${percentFake}%`
      } else {
        //  console.log(video.duration);
        var percentReal = ((video.duration / 2) / video.duration) * 100
        progressBar.style.flexBasis = `${percentReal}%`
      }
    },

    salvar() {
      if (this.files.length >= 0) {
        console.log('Inicio_vasio')
      } else {
        console.log('Inicio_ok')
        this.enviarArquivo()
      }

      if (this.filesPausa.length >= 0) {
        console.log('pausavasio')
      } else {
        console.log('pausa_ok')
        this.enviarArquivoPausa()
      }
      if (this.filesFinal.length >= 0) {
        console.log('Finalvasio')
      } else {
        console.log('Final_ok')
        this.enviarArquivoFinal()
      }
    },

    listar() {
      ThumbNailsService.getThumbnailVSL_Id(this.vslId).then(resposta => {
        this.Thumb = resposta.data
        this.valid = (this.Thumb[0].tumb_start.length >= 1)
        this.validPausa = (this.Thumb[0].tumb_pausa.length >= 1)
        this.validFinal = (this.Thumb[0].tumb_end.length >= 1)

        this.imageUrlInicio = (this.Thumb[0].tumb_start)
        this.imageUrlPausa = (this.Thumb[0].tumb_pausa)
        this.imageUrlEnd = this.Thumb[0].tumb_end
      }).catch(e => {
        console.log(e)
      })
    },

    enviarArquivo() {
      const formData = new FormData()
      formData.append('video', this.files)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_inicio/`)
      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }.bind(this),
        })
        .then(response => {
          this.urlImagem = response.data.data.fileUrl
          this.NameImagem = response.data.data.fileNameOrigin
          this.key_name = response.data.data.key_filename
          if (response.data.data.status == 201) {
            this.updateSubmit()
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
    },
    enviarArquivoPausa() {
      const formData = new FormData()

      formData.append('video', this.filesPausa)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_Pause/`)

      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }.bind(this),
        })

        .then(response => {
          this.urlImagemPausa = response.data.data.fileUrl
          this.NameImagemPausa = response.data.data.fileNameOrigin
          this.key_namePausa = response.data.data.key_filename
          if (response.data.data.status == 201) {
            this.updateSubmitPausa()
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
    },
    enviarArquivoFinal() {
      const formData = new FormData()
      formData.append('video', this.filesFinal)
      formData.append('caminho', `${this.userData.user_file_key}UploadImageThumb/Thumbnail_Final/`)

      axios.post(`${this.VUE_APP_HOST_API_AWS_S3}/thumb`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }.bind(this),
        })

        .then(response => {
          this.urlImagemFinal = response.data.data.fileUrl
          this.NameImagemFinal = response.data.data.fileNameOrigin
          this.key_nameFinal = response.data.data.key_filename
          if (response.data.data.status == 201) {
            this.updateSubmitFinal()
          }
        })
        .catch(() => {
          console.log('FAILURE!!')
        })
    },

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    uploadImageUrl(e, classImage) {
      const pictureImage = document.querySelector(`.${classImage}`)
      const pictureImageTxt = ''
      if (classImage === 'picture__image') {
        this.files = e.target.files[0]
      }
      if (classImage === 'picture__imageUpload') {
        this.filesPausa = e.target.files[0]
      }
      if (classImage === 'pictureFinal') {
        this.filesFinal = e.target.files[0]
      }
      if (this.files) {
        const reader = new FileReader()

        reader.addEventListener('load', function (e) {
          const readerTarget = e.target

          const img = document.createElement('img')
          if (classImage === 'picture__image') {
            this.imageUrlInicio = readerTarget.result
          }
          if (classImage === 'picture__imageUpload') {
            this.imageUrlPausa = readerTarget.result
          }
          if (classImage === 'pictureFinal') {
            this.imageUrlEnd = readerTarget.result
          }
          img.src = readerTarget.result

          img.classList.add('picture__img')
          img.setAttribute('style', 'max-width:100%;')
          pictureImage.innerHTML = ''
          pictureImage.appendChild(img)
        })
        if (classImage === 'picture__image') {
          reader.readAsDataURL(this.files)
        }
        if (classImage === 'picture__imageUpload') {
          reader.readAsDataURL(this.filesPausa)
        }
        if (classImage === 'pictureFinal') {
          reader.readAsDataURL(this.filesFinal)
        }
      } else {
        pictureImage.innerHTML = pictureImageTxt
      }
    },
    UploadImg() {
      const inputFile = document.querySelector('#picture__input')
      const pictureImage = document.querySelector('.picture__image')
      const pictureImageTxt = ''
      pictureImage.innerHTML = pictureImageTxt

      inputFile.addEventListener('change', e => {
        const inputTarget = e.target
        console.log(inputTarget)
        const file = inputTarget.files[0]
        this.files = inputTarget.files[0]

        if (file) {
          const reader = new FileReader()

          reader.addEventListener('load', e => {
            const readerTarget = e.target

            const img = document.createElement('img')
            img.src = readerTarget.result
            img.setAttribute('style', 'max-width:100%;')
            img.classList.add('picture__img')

            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })

          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = pictureImageTxt
        }
      })
    },
    UploadImgPausa() {
      const inputFile = document.querySelector('#Input_UploadPausa')
      const pictureImage = document.querySelector('.picture__imageUpload')
      const pictureImageTxt = ''
      pictureImage.innerHTML = pictureImageTxt

      inputFile.addEventListener('change', e => {
        const inputTarget = e.target
        const file = inputTarget.files[0]
        this.filesPausa = inputTarget.files[0]
        if (file) {
          const reader = new FileReader()

          reader.addEventListener('load', e => {
            const readerTarget = e.target

            const img = document.createElement('img')
            img.src = readerTarget.result
            img.classList.add('picture__img')
            img.setAttribute('style', 'max-width:100%;')
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })

          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = pictureImageTxt
        }
      })
    },
    UploadImgFinal() {
      const inputFile = document.querySelector('#Input_UploadFinal')
      const pictureImage = document.querySelector('.pictureFinal')
      const pictureImageTxt = ''
      pictureImage.innerHTML = pictureImageTxt

      inputFile.addEventListener('change', e => {
        const inputTarget = e.target
        const file = inputTarget.files[0]
        this.filesFinal = inputTarget.files[0]

        if (file) {
          const reader = new FileReader()

          reader.addEventListener('load', e => {
            const readerTarget = e.target

            const img = document.createElement('img')
            img.src = readerTarget.result
            img.classList.add('picture__img')
            img.setAttribute('style', 'max-width:100%;')
            pictureImage.innerHTML = ''
            pictureImage.appendChild(img)
          })

          reader.readAsDataURL(file)
        } else {
          pictureImage.innerHTML = pictureImageTxt
        }
      })
    },

    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbinicio/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_start":"${this.urlImagem
        }","tumb_key_name_start":"${this.key_name
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          console.log(response)
          this.listar()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })

        .catch(err => console.error(err))
    },
    updateSubmitPausa() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbpausa/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_pausa":"${this.urlImagemPausa
        }","thumb_key_name_pausa":"${this.key_namePausa
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          console.log(response)
          this.listar()
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })

        .catch(err => console.error(err))
    },
    updateSubmitFinal() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbfinal/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_end":"${this.urlImagemFinal
        }","thumb_key_name_end":"${this.key_nameFinal
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          console.log(response)
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
          this.listar()
        })
        .catch(err => console.error(err))
    },

    DeletThumb() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbinicio/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_start":"${this.url
        }","tumb_key_name_start":"${this.key
        }","id_vsl":"${this.vslId
        }"}`,
      })
        .then(response => {
          if (response.status == 200) {
            this.deletarAWS
            this.listar()
          }
        })

        .catch(err => console.error(err))
    },
    DeletThumbPausa() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbpausa/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_pausa":"${this.url
        }","thumb_key_name_pausa":"${this.key
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          if (response.status == 200) {
            this.deletarAWS
            this.listar()
          }
        })

        .catch(err => console.error(err))
    },
    DeletThumbFinal() {
      this.url = ''
      this.key = ''
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/tumbfinal/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: `{"tumb_end":"${this.url
        }","thumb_key_name_end":"${this.key
        }","id_vsl":"${this.vslId
        }"}`,
      })

        .then(response => {
          if (response.status == 200) {
            this.deletarAWSFinal()
            this.listar()
          }
        })

        .catch(err => console.error(err))
    },

    deletarAWS(Thumb) {
      console.log('Thumb')
      console.log(Thumb)

      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: {
          key: Thumb,
          delete: '',
        },
      }
      axios.request(options).then(function (response) {
        this.listar()
      }).catch(error => {
        console.error(error)
      })
    },
    deletarAWSPausa(Thumb) {
      console.log('Thumb')
      console.log(Thumb)
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: {
          key: Thumb,
          delete: '',
        },
      }

      axios.request(options).then(response => {

      }).catch(error => {
        console.error(error)
      })
    },
    deletarAWSFinal(Thumb) {
      console.log('Thumb')
      console.log(Thumb)
      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: {
          key: Thumb,
          delete: '',
        },
      }

      axios.request(options).then(response => {
        // console.log('responsedeleteaws')
        // console.log(response)
        // document.location.reload(true);
      }).catch(error => {
        console.error(error)
      })
    },

  },

}

</script>
<style lang="scss" scoped>
@import '@/assets/scssThumbnails/thumbInicio.scss';
@import '@/assets/scssThumbnails/thumbPausa.scss';
@import '@/assets/scssThumbnails/thumFinal.scss';

.tb {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0px;
  border: none;
}

.picture {
  width: 100%;
}

.image_src {
  max-width: 100%;
}

.player {
  max-width: 900px;
  /* //border: 4px solid rgba(0,0,0,.2);
 //box-shadow: 0 0 20px rgba(0,0,0,.2); */
  position: relative;
  font-size: 20;
  overflow: hidden;
}

.player {
  width: 100%;
  height: 500px;
}

.player:fullcreen {
  max-width: none;
  width: 100%;
}

.player:-webkit-full-screen {
  max-width: none;
  width: 100%;
}

.player:-ms-full-screen {
  max-width: none;
  width: 100%;
}

.player:-moz-full-screen {
  max-width: none;
  width: 100%;
}

.player_my_video {
  min-width: 102%;
  height: 500px;
}

.player_my_controls {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 97%;
  transform: translateY(100%) translateY(-31%);
  transition: all .3s;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, .2);
}

.progress_my_filled {
  width: 80%;
  /* //background: #ffc600; */
  background: rgba(255, 226, 40, 0.815);
  flex: 0;
  flex-basis: 0%;
}

.player:hover .player_my_controls {
  transform: translateY(0);
}

.player_my_controls>* {
  flex: 1;
}

.progress {
  flex: 10;
  position: relative;
  display: flex;
  flex-basis: 100%;
  height: 10px;
  transition: height .3s;
  background: rgba(0, 0, 0, .25);
  cursor: pointer;
  /* ew-resize*/
}

.player_my_button {
  background: none;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  outline: 0;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
  max-width: 50px;

}

.playerSlider {
  display: block;
  width: 10px;
  height: 30px;
}

input[type=range] {
  -webkit-appearance: none !important;
  background: transparent;
  width: 100%;
  margin: 0 5px;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: rgba(255, 255, 255, .8);
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

input[type=range]::-webkit-slider-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  background: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .2);
}

input[type=range]:focus {
  outline: none;

}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: #ff0;

}

/* Mozila Linha do volume*/

input[type=range]::-moz-range-track {
  width: 100%;
  height: 0.1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: #fff;
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

/* Mozila Circulo do volume*/

input[type=range]::-moz-range-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  border-color: none;
  background: #fff;
  cursor: pointer;
}

.fullscreenbtn {

  margin-left: 75%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.button_volume {

  margin-left: -2%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.PictureInPicture {
  margin-left: -9%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.playpause {

  border-radius: 50px;
  background-image: url(../img/play.svg);
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10 !important;
}

.playpause {
  opacity: 1;
  transition: opacity 400ms;
}

.playpause[hidden] {
  opacity: 0;

}

.iniciar {
  border: 2px solid;
  border-style: none;
  border-radius: 15px 50px;
  display: block;
  width: 50%;
  height: 50%;
  position: absolute;
  flex-direction: column-reverse;
  display: flex;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  align-items: center;
  background-size: contain;
  background-position: center;

}

.video-banner {
  position: relative;
}

.video-banner .overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 1;
}

.loader {
  height: 70px;
  width: 200px;
  display: flex;
  align-items: center;
}

.loader .stroke {
  display: block;
  position: relative;
  background: #f1f1f1;
  height: 50%;
  width: 15%;
  border-radius: 50px;
  margin: 0 5px;
  align-items: center;
  animation: animate 1.2s linear infinite;
}

/* .playImagem {
    width: 64px;
    height: 64px;
    cursor: pointer;
  } */

h2 {
  position: relative;
  align-self: center;
  font-family: Arial, Helvetica, sans-serif;
}

@keyframes animate {
  50% {
    height: 20%;
  }

  100% {
    height: 100%;
  }
}

.stroke:nth-child(1) {
  animation-delay: 0s;
}

.stroke:nth-child(2) {
  animation-delay: 0.3s;
}

.stroke:nth-child(3) {
  animation-delay: 0.6s;
}

.stroke:nth-child(4) {
  animation-delay: 0.9s;
}

.stroke:nth-child(5) {
  animation-delay: 0.6s;
}

.stroke:nth-child(6) {
  animation-delay: 0;
}

.stroke:nth-child(7) {
  animation-delay: 0.2s;
}

.stroke:nth-child(8) {
  animation-delay: 0.5s;
}

.stroke:nth-child(9) {
  animation-delay: 0.1s;
}

.stroke:nth-child(10) {
  animation-delay: 0s;
}

.stroke:nth-child(11) {
  animation-delay: 0.3s;
}

.stroke:nth-child(12) {
  animation-delay: 0.6s;
}

.stroke:nth-child(13) {
  animation-delay: 0.3s;
}

#context-menu {
  position: fixed;
  width: 170px;
  height: 20px;
  border: #000;
  background: rgba(40, 38, 38, 0.856);
  transform: scale(0);
  transform-origin: top left;
  padding: 8px 8px 8px 8px;
}

#context-menu.active {
  transform: scale(1);
  transition: transform 200ms ease-in-out;
}

#context-menu a {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  color: #eee;
  text-decoration: none;
}

#context-menu .item:hover {
  background: #555;
}

.playpausebg {
  height: 100%;
  background-size: cover;

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playpausebg {
  opacity: 1;
  transition: opacity 400ms;
}

.playpausebg[hidden] {
  opacity: 0;

}

.playEndedbg {

  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
  height: 100%;
  background-size: cover;
}

.playEndedbg {
  opacity: 1;
  transition: opacity 400ms;
}

.playEndedbg[hidden] {
  opacity: 0;

}
</style>
